module.exports = __webpack_public_path__ + "img/3.4e34e9b2.jpg";